import classNames from "classnames";
import { twMerge } from "tailwind-merge";

type Props = {
  className?: string;
  animate?: boolean;
};

const Indicator = ({ className, animate = true }: Props) => (
  <span
    data-testid="indicator"
    className={twMerge(
      "block h-2.5 w-2.5 rounded-full border border-white bg-red-600 ring-2 ring-red-300",
      classNames({ "animate-scaleIn": animate }),
      className,
    )}
  />
);

export default Indicator;
